export const common = {
    identifier_type: {
        presence: { allowEmpty: false },
    },
    identifier_number: {
        type: 'string',
        length: { minimum: 3, maximum: 65 },
        presence: { allowEmpty: false },
    },
};

export const travelAgencyData = {
    name: {
        type: 'string',
        length: { minimum: 1, maximum: 120 },
        presence: { allowEmpty: false },
    },
    consortia_affiliation: {
        presence: { allowEmpty: false },
    },
    address: {
        type: 'string',
        length: { minimum: 1, maximum: 120 },
        presence: { allowEmpty: false },
    },
    city: {
        type: 'string',
        length: { minimum: 1, maximum: 100 },
        presence: { allowEmpty: false },
    },
    state: {
        type: 'string',
        length: { minimum: 1, maximum: 100 },
        presence: { allowEmpty: false },
    },
    country: {
        type: 'string',
        length: { minimum: 1, maximum: 100 },
        presence: { allowEmpty: false },
    },
    zip: {
        type: 'string',
        length: { minimum: 3, maximum: 12 },
        presence: { allowEmpty: false },
    },
};
